/**
 * /admin/fic-reports — FIC report listing (route shell).
 * Screen impl in `./fic-reports-screen.tsx`, lazy-loaded.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/fic-reports')({
  component: lazyRouteComponent(
    () => import('./fic-reports-screen'),
    'AdminFicReports',
  ),
});
